/** Pracovní název produktu. Finální název se mění jen tady (a v package.json / README). */
export const APP_NAME = 'TCmark';

/** Verze appky (ručně se zvyšuje při vydání). */
export const APP_VERSION = '0.1.0';
